import { httpClient } from "@/services";
import getClonedObject from "@/helper/getClonedObject";

const recArrChild = (arr, val) => {
	return !!arr.find(value => {
		if (value.name === val) {
			return true;
		} else if (value.name !== val && value.children) {
			return recArrChild(value.children, val);
		}
		return false;
	});
};

export default {
	state: {
		token: localStorage.getItem("auth-token"),
		isAuth: false,
		profileImage: null,
		role: null,
		listPermission: [],
		permissionDefault: null,
		tabPermissionTemp: {},
		tabPermission: {},
		sectionPermissions: {},
		activeSection: null,
		sectionLinkPermissions: {},
		activeLinkSection: null,
		linksPermissions: null,
		sessionTime: 0,
		alert: null,
		warning: null,
		close_modal: false,
		isCustomers: null,
		routerInitDone: false,
		company_id: null,
		roleLogin: null,
		customersLogin: null,
		isLogin: null,
	},
	mutations: {
		SET_ROUTER_INIT(state, payload) {
			state.routerInitDone = payload;
		},
		SET_SESSION_TIME(state, payload) {
			state.sessionTime = payload * 1000;
		},
		IS_LOGIN_USER(state, payload) {
			state.isAuth = payload;
			if (!payload) localStorage.clear();
		},
		updateIsCustomers(state, payload) {
			state.isCustomers = payload;
		},
		updateIsLogin(state, payload) {
			state.isLogin = payload;
		},
		ROLE(state, payload) {
			state.role = payload;
		},
		GET_TOKEN(state, payload) {
			state.token = payload;
		},
		SET_PERMISSIONS_LIST(state, payload) {
			const list = [];
			const recArrSet = (payload) => {
				for (const i of payload) {
					list.push({ name: i.name, selected: i.selected, id: i.id });
					if (i.children) recArrSet(i.children);
				}
			};
			recArrSet(payload);
			state.listPermission = list;
		},
		SET_PERMISSIONS_DEFAULT(state, payload) {
			state.permissionDefault = payload;
		},
		SET_SECTION_PERM(state, payload) {
			const section = state.permissionDefault?.find((value) => {
				if (value.name === payload) return true;
				else if (value.name !== payload && value.children) {
					return recArrChild(value.children, payload);
				}
				return false;
			});

			if (section) {
				if (section.name === payload) {
					const obj = {};
					const recArrSet = (arr) => {
						for (const item of arr) {
							state.sectionPermissions[item.id] = item.selected;
							if (item.children) {
								recArrSet(item.children);
							}
						}
					};
					state.sectionPermissions = obj;
					const firstArr = [ section ];
					recArrSet(firstArr);
					state.activeSection = section;
				} else {
					const findSection = (obj) => {
						let section;
						for (const item of obj.children) {
							let sec;
							if (item.name === payload) sec = item;
							else if (item.name !== payload && item.children) sec = findSection(item);
							if (sec) section = sec;
						}
						return section;
					};
					const child = findSection(section);
					const obj = {};
					const recArrSet = (arr) => {
						for (const item of arr) {
							state.sectionPermissions[item.id] = item.selected;
							if (item.children) {
								recArrSet(item.children);
							}
						}
					};
					state.sectionPermissions = obj;
					const firstArr = [ child ];
					recArrSet(firstArr);
					state.activeSection = section;

					const getTempTabPermission = (arr) => {
						if (arr.children) {
							for (const item of arr.children) {
								if (item.id !== 8 && item.id !== 9 && item.id !== 11 && item.id !== 10) {
									state.tabPermissionTemp[item.id] = item.children;
								}
							}
						}
					};

					const getTabPermission = (obj) => {
						const keys = Object.keys(obj);
						keys.forEach(key => {
							const el = obj[key];
							state.tabPermission[key] = {};
							el?.forEach(function(item) {
								state.tabPermission[key][item.id] = item.selected;
							});
						});
					};

					getTempTabPermission(child);
					getTabPermission(state.tabPermissionTemp);
				}
			}
		},

		SET_ALERT(state, payload) {
			state.alert = payload;
			setTimeout(() => {
				state.alert = null;
			}, 4000);
		},
		SET_WARNING(state, payload) {
			state.warning = payload;
		},
		updateLinksPermissions(state, payload) {
			const linksPermissions = {};
			for (const itemLink of payload) {
				const recArrChild = (arr, val) => {
					return !!arr.find(value => {
						if (value.id === val) {
							return true;
						} else if (value.id !== val && value.children) {
							return recArrChild(value.children, val);
						}
						return false;
					});
				};
				const section = state.permissionDefault?.find((value) => {
					if (value.id === itemLink) return true;
					else if (value.id !== itemLink && value.children) {
						return recArrChild(value.children, itemLink);
					}
					return false;
				});

				if (section) {
					if (section.id === itemLink) {
						const recArrSet = (arr) => {
							for (const item of arr) {
								state.sectionLinkPermissions[item.id] = item.selected;
								if (item.children) {
									recArrSet(item.children);
								}
							}
						};
						const firstArr = [ section ];
						recArrSet(firstArr);
						state.activeLinkSection = section;
					} else {
						const findSection = (obj) => {
							let section;
							for (const item of obj.children) {
								let sec;
								if (item.id === itemLink) sec = item;
								else if (item.id !== itemLink && item.children) sec = findSection(item);
								if (sec) section = sec;
							}
							return section;
						};
						const child = findSection(section);
						const recArrSet = (arr) => {
							for (const item of arr) {
								state.sectionLinkPermissions[item.id] = item.selected;
								if (item.children) {
									recArrSet(item.children);
								}
							}
						};
						const firstArr = [ child ];
						recArrSet(firstArr);
						state.activeLinkSection = section;
						linksPermissions[itemLink] = state.sectionLinkPermissions;
					}
				}
				state.linksPermissions = getClonedObject(linksPermissions);
			}
		},
		updateImage(state, payload) {
			state.profileImage = payload;
		},
		updateCompanyId(state, { company_id }) {
			state.company_id = company_id;
		},
		updateLiginInfo(state, payload ) {
			const { role, customers } = payload;
			state.roleLogin = role;
			state.customersLogin = customers;
		}
	},
	actions: {
		onLinksPermissions({ commit }, payload) {
			commit('updateLinksPermissions', payload);
		},
		async onNotification(notification_id) {
			try {
				await httpClient.post(`/notification/${ notification_id }`);
			} catch (e) {
				throw new Error(e);
			}
		},
		async onVersion() {
			try {
				await httpClient.post('/version');
			} catch (e) {
				throw new Error(e);
			}
		},
		setPermitToSection({ commit }, payload) {
			commit('SET_SECTION_PERM', payload);
		},
		async login({ commit }, values) {
			try {
				const { data } = await httpClient.post('/login', values);

				if (data && !data.error) {
					const { access_token, version_show, version, token_type, notification, notification_show } = data;
					const token = token_type + ' ' + access_token;

					commit('updateLiginInfo', data);
					localStorage.clear();
					localStorage.setItem("version", JSON.stringify(version));
					localStorage.setItem("version_show", version_show);
					localStorage.setItem("versionShowPopup", "true");
					localStorage.setItem("notification", JSON.stringify(notification));
					localStorage.setItem("notification_show", notification_show);
					localStorage.setItem("notificationShowPopup", "true");
					localStorage.setItem("auth-token", token);

					commit('IS_LOGIN_USER', true);
					commit('GET_TOKEN', token);
				}
				return data;
			} catch (error) {
				console.error(error);
			}
		},
		async onLogout({ commit }) {
			try {
				const { status } = await httpClient.post('/logout');

				if (status === 200) {
					commit('IS_LOGIN_USER', false);
					commit('GET_TOKEN', false);
					localStorage.clear();
				}
			} catch (error) {
				console.error(error);
			}
		},
		async onLogin({ commit, dispatch }, pathName) {
			try {
				const { data, status } = await httpClient.post('/isLogin');

				if (status === 200) {
					const { message, permissions, role, expires_in: expiresIn, image, customers } = data;

					if (message) {

						commit('updateIsLogin', data);
						commit('SET_PERMISSIONS_DEFAULT', permissions);
						commit('SET_PERMISSIONS_LIST', permissions);
						commit('ROLE', role);
						commit('updateImage', image);
						commit('SET_SESSION_TIME', expiresIn);
						commit('IS_LOGIN_USER', message);
						commit('updateIsCustomers', customers);

						if (pathName) {
							dispatch('setPermitToSection', pathName);
						}

						return message;
					}

				} else {
					commit('IS_LOGIN_USER', false);
					commit('ROLE', []);
					commit('SET_PERMISSIONS_DEFAULT', []);
					commit('SET_PERMISSIONS_LIST', []);
					commit('SET_SESSION_TIME', 0);
					commit('updateIsCustomers', false);
				}

				return data;
			} catch (error) {
				return 'error';
			}
		},
		async getCompanyId({ commit }) {
			try {
				const { data } = await httpClient.get(`/company-id/`);
				if (data) {
					commit('updateCompanyId', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async sendMessageReset(context, values) {
			try {
				const { data } = await httpClient.post('/reset', values);
				return data;
			} catch (e) {
				throw new Error(e);
			}
		},
		async isActivUpdate(context, values) {
			try {
				const { data } = await httpClient.get(`/restore?${ values }`);
				return data;
			} catch (e) {
				throw new Error(e);
			}
		},
		async updatePass(context, values) {
			try {
				const { data } = await httpClient.post('/restore', values);
				return data;
			} catch (e) {
				throw new Error(e);
			}
		},
		setAlert({ commit }, payload) {
			commit('SET_ALERT', payload);
		},
		setWarning({ commit }, payload) {
			commit('SET_WARNING', payload);
		}
	},
	getters: {
		version: (s) => s.version,
		permissions: (s) => s.sectionPermissions,
		getPermissionsList: (s) => s.listPermission,
		permissionsDefault: (s) => s.permissionDefault,
		authState: (s) => s.isAuth,
		role: (s) => s.role,
		profileImage: (s) => s.profileImage,
		token: s => {
			const token = localStorage.getItem('auth-token');
			s.token = token ?? '';
		},
		getAlert: s => s.alert,
		getWarning: s => s.warning,
		getTabPermission: s => s.tabPermission,
		isCustomers: s => s.isCustomers,
		linksPermissions: s => s.linksPermissions,
		company_id: s => s.company_id,
		roleLogin: s => s.roleLogin,
		customersLogin: s => s.customersLogin,
		isLogin: s => s.isLogin,
	}
};
